import { MasterBoxResponse, DeleteMasterBoxRequest, GetAllMasterBoxesRequest } from "services/interface";
import styled from "@emotion/styled";
import { Col, Row, message } from "antd";
import { Dispatch, FC, SetStateAction } from "react";
import TableSettingBox from "./TableSettingBox";
import { useQueryClient } from "@tanstack/react-query";
import { useDeleteMasterBox } from "hooks/useMasterData";

interface SettingBoxListProps {
  data: MasterBoxResponse | undefined;
  refetch: () => void;
  limit: number;
  offset: number;
  setLimit: Dispatch<SetStateAction<number>>;
  setOffset: Dispatch<SetStateAction<number>>;
  searchParams: GetAllMasterBoxesRequest;
  setSearchParams: Dispatch<SetStateAction<GetAllMasterBoxesRequest>>;
  onSearch: () => void;
}

const SettingBoxList: FC<SettingBoxListProps> = ({
  data,
  refetch,
  limit,
  offset,
  setLimit,
  setOffset,
  searchParams,
  setSearchParams,
  onSearch,
}) => {
  const { mutate, isPending } = useDeleteMasterBox();

  const queryClient = useQueryClient();

  const onDeleteConfigs = (id: number) => { // ✅ แก้ไข: เปลี่ยนจาก string เป็น number เพื่อรองรับ SERIAL PRIMARY KEY
    console.log('🗑️ [SettingBoxList Component] onDeleteConfigs called with id:', id);
    
    const requestData: DeleteMasterBoxRequest = {
      id: id,
    };
    
    console.log('🗑️ [SettingBoxList Component] requestData:', requestData);

    mutate(requestData, {
      onSuccess: async (res) => {
        console.log('🗑️ [SettingBoxList Component] onSuccess response:', res);
        console.log('🗑️ [SettingBoxList Component] res keys:', Object.keys(res));
        console.log('🗑️ [SettingBoxList Component] res.success:', res.success);
        console.log('🗑️ [SettingBoxList Component] res.status:', (res as any).status);
        console.log('🗑️ [SettingBoxList Component] res.error_message:', (res as any).error_message);
        console.log('🗑️ [SettingBoxList Component] typeof res.success:', typeof res.success);
        
        // Check multiple possible success indicators
        const isSuccess = res.success === true || 
                         (res as any).status === 'success' || 
                         (res as any).status === 200 ||
                         (!(res as any).error_message && res.data);
        
        console.log('🗑️ [SettingBoxList Component] isSuccess:', isSuccess);
        
        if (isSuccess) {
          await queryClient.refetchQueries({
            queryKey: ["masterBoxes"],
            type: "active",
          });
          message.success("ลบกล่องสำเร็จ");
          refetch();
        } else {
          console.log('🗑️ [SettingBoxList Component] Success is false, showing error');
          message.error("ลบกล่องไม่สำเร็จ");
        }
      },
      onError: (error) => {
        console.log('🗑️ [SettingBoxList Component] onError:', error);
        message.error(`ลบกล่องไม่สำเร็จ: ${error.message}`);
      },
    });
  };

  return (
    <WrapperAll>
      <Row
        gutter={[16, 16]}
        style={{ backgroundColor: "#EFEFEF", overflow: "auto" }}
      >
        <Col span={24}>
          <CardWrapperTable>
            <TableSettingBox
              data={data?.data?.master_boxes}
              onDeleteConfigs={onDeleteConfigs}
              limit={limit}
              offset={offset}
              setLimit={setLimit}
              setOffset={setOffset}
              total={data?.data?.total_record?.toString() || "0"}
              searchParams={searchParams}
              setSearchParams={setSearchParams}
              onSearch={onSearch}
              refetch={refetch}
            />
          </CardWrapperTable>
        </Col>
      </Row>
    </WrapperAll>
  );
};

export default SettingBoxList;
const WrapperAll = styled.div`
  background-color: #efefef;
`;

const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;
`;
